export enum ModalVariants {
  normal = 'normal',
  warning = 'warning',
  error = 'error',
  success = 'success',
}

export enum ModalSize {
  large = 'large',
  medium = 'medium',
}
